import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BrdsqlService } from '../../services/brdsql.service';
import { ActivatedRoute, Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-editplot-manager',
  templateUrl: './editplot-manager.component.html',
  styleUrls: ['./editplot-manager.component.css']
})
export class EditplotManagerComponent implements OnInit {

  yearSelected?: string = "";
  supzoneSelected?: string = "";
  plotinSupzone?: any = [];
  plotSelect?: any = {};
  plotCanEdit? = false;
  requestdata?: any = [];
  @ViewChild('tb_data') tb_data!: ElementRef;
  formSelect?: string = "";
  canetype?: any = [];
  defaultValue?:string[] = ["","X","X"];

  // edit_type = new FormControl("1" ,Validators.required);  // หัวข้อการแก้ไข

  constructor(
    private brdservice: BrdsqlService,
    private route: ActivatedRoute,
    private router: Router) {

    if (localStorage.getItem('yearCr')) {
      this.yearSelected = localStorage.getItem('yearCr');
    }
    if (localStorage.getItem('supzone')) {
      this.supzoneSelected = localStorage.getItem('supzone');
    }

    this.canetype = brdservice.canetype;

    // if(this.plotSelect.length > 0) { this.plotCanEdit = true}
    // console.log('plotselect' ,this.plotSelect);

  }

  ngOnInit(): void {
    this.getPlotZone();
    this.loadSubject();
    this.requestData();
  }

  getPlotZone(): void {
    let yearid = localStorage.getItem('yearTh')
    this.brdservice.getCpsupzone(yearid, this.supzoneSelected)
      .subscribe({
        next: (data: any) => {
          this.plotinSupzone = data.recordset;
          // console.log('plotinSupzone :' ,this.plotinSupzone);
          // setTimeout(() => {
          //   $(this.tb_data.nativeElement).DataTable();
          // }, 0);
        },
        error: (e) => console.error(e)
      });
  }

  selectData(f: any) {
    this.plotSelect = this.plotinSupzone.filter((el: { itid: any; }) => el.itid == f.itid);
    this.plotSelect = this.plotSelect[0];
    console.log('plotSelect :' ,this.plotSelect);
    this.plotCanEdit = true;
    this.getCpFinance();
    this.getCpFactor();
  }

  // ข้อมูลการขอสินเชื่อ ของแปลงอ้อย
  financeList?: any = [];
  getCpFinance() {
    let plotSelect = this.plotSelect.itid;
    let yearid = localStorage.getItem('yearTh')
    this.brdservice.getCpFinance(yearid, plotSelect)
      .subscribe({
        next: (data: any) => {
          this.financeList = data.recordset;
          // console.log('financeList :', this.financeList);
          // console.log('haveFinance :', this.financeList.length);
          this.plotCanEdit = this.financeList.length > 0 ? false : true ;
          // console.log('plotCanEdit :', this.plotCanEdit);
        },
        error: (e) => console.error(e)
      });
  }
  // ข้อมูลการขอสินเชื่อ ของแปลงอ้อย
  factorList?: any = [];
  getCpFactor() {
    let plotSelect = this.plotSelect.itid;
    let yearid = localStorage.getItem('yearTh')
    this.brdservice.getCpFactor(yearid, plotSelect)
      .subscribe({
        next: (data: any) => {
          this.factorList = data.recordset;
          // console.log('factorList :', this.factorList);
          this.plotCanEdit = this.factorList.length > 0 ? false : true ;
          // console.log('plotCanEdit :', this.plotCanEdit);
          // setTimeout(() => {
          //   $(this.tb_data.nativeElement).DataTable();
          // }, 0);
        },
        error: (e) => console.error(e)
      });
  }

  subjectList?: any = [];
  loadSubject() {
    this.brdservice.loadTitle()
    .subscribe({
      next: (data: any) => {
        this.subjectList = data.recordset;
      },error: (e) => console.error(e)
    });
  }

  // บันทึกข้อมูล การขอแก้ไขแปลงของ ผจก.โซน
  saveRequestEditPlotManager(f:any) {
      Swal.fire({
        title: 'ยืนยันการบันทึกข้อมูล?',
        // text: 'You will not be able to recover this file!',
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'OK ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.brdservice.saveAddRequestEditPlotManager(f)
          .subscribe({
            next: (data:any) => {
              console.log('response:' ,data);
              if(data.rowsAffected == 1) {
                Swal.fire('บันทึกข้อมูลสำเร็จ!','success')
                this.refresh();
              } else {
                Swal.fire({icon: 'error',title: 'Oops...',text: 'บันทึกข้อมูลไม่สำเร็จ!',footer: '<a href="">กรุณาลองใหม่อีกรอบ</a>'})
              }
            }
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'ยกเลิกการบันทึกข้อมูล',
            'cancle'
          )
        }
        // บันทึกแล้วรีเฟรซข้อมูล
        // this.router.navigateByUrl('/ListComponent', { skipLocationChange: true }).then(() => {
        //   this.router.navigate(['/editplotmanager']);
        // });

      })
    };

  // โหลดข้อมูลการขอแก้ไขแปลงของโซน
  dataApi?: any = [];
  requestData() {
    this.dataApi = [];
    this.brdservice.listRequestEditPlotManager()
      .subscribe({
        next: (data: any) => {
          this.dataApi = data.recordset;
          setTimeout(() => {
            $(this.tb_data.nativeElement).DataTable();
          }, 0);
        }, error: (e) => console.error(e)
      })
  }    

  refresh() {
    this.router.navigateByUrl('/ListComponent', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/editplotmanager']);
    });
    // this.router.navigateByUrl('/editplotmanager');
  }  
  
  showForm(event) {
    const sForm = event.target.value;
    this.formSelect = sForm;
    this.defaultValue[0] =  this.formSelect;
    console.log('defaultValue:' ,this.defaultValue[0]);
  }

  fmname?:string = "";
  sheachFm(event) {
    const fmcode = event.target.value;
    this.brdservice.searchFmcode(fmcode)
    .subscribe({
      next: (data: any) => {
        this.fmname = data.recordset[0].fmname;
        // console.log('fmname :', this.fmname);
      }
    })
  }
  

}
